var AbstractDataModel = require("./AbstractDataModel")
var getQueryParam = require("../helpers/viewmodels").getQueryParam

function TransactionTypeModel(data) {
  var self = this;
  var x = null;

  // Predicate this ViewModel on the Abstract class of a View Model
  // This tacks on additional functionality, including the ability to
  // read URL query parameters, and an observable binding predicated
  // on another object's obcervable-bound variables
  AbstractDataModel.apply(self, arguments);


  // If data was passed in, initialize the object
  if (data) {
    if (getQueryParam('debug') === 'true') {
      self.data = data;
    }

    // Extract all the properties of the data into this model
    for (prop in data) {
      if (data.hasOwnProperty(prop)) {
        self[prop] = data[prop];
      }
    }
  }


  return self;
};


TransactionTypeModel.prototype = Object.create(AbstractDataModel.prototype);
TransactionTypeModel.prototype.constructor = TransactionTypeModel;

if (typeof exports !== 'undefined') {
module.exports = TransactionTypeModel
}
